// src/components/HeaderTitle.jsx
import PropTypes from "prop-types";

export default function HeaderTitle({
  role = "Administrateur",
  title = "",
  align = "center", // "left" | "center" | "right"
  className = "",
}) {
  const alignment =
    align === "left"
      ? "text-left"
      : align === "right"
      ? "text-right"
      : "text-center";

  return (
    <header className={`${alignment} ${className}`}>
      <p className="text-[11px] tracking-[0.35em] text-slate-700 dark:text-slate-300">
        {String(role).toUpperCase()}
      </p>
      <h1
        className="mt-1 text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-wide
                     text-slate-900 dark:text-slate-100 font-montserrat uppercase"
      >
        {title}
      </h1>
    </header>
  );
}

HeaderTitle.propTypes = {
  role: PropTypes.string,
  title: PropTypes.string.isRequired,
  align: PropTypes.oneOf(["left", "center", "right"]),
  className: PropTypes.string,
};
